import * as signalR from "@microsoft/signalr";


const connection = new signalR.HubConnectionBuilder()
  .withUrl(process.env.REACT_APP_SIGNALR_URL)
  .withAutomaticReconnect()
  .configureLogging(signalR.LogLevel.Information)
  .build();

// Reconnect logs
connection.onreconnecting((err) => {
  console.log("SignalR reconnecting...", err);
});

connection.onreconnected((id) => {
  console.log("SignalR reconnected:", id);
});

connection.onclose((err) => {
  console.log("SignalR closed:", err);
});

export default connection;